import React from 'react';
import propTypes from './propTypes';

const HourlyWork = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5.5" cy="16.5" r="1.5" fill="currentColor" />
    <circle cx="12.5" cy="16.5" r="1.5" fill="currentColor" />
    <path d="M9.9792 2H4C2.34315 2 1 3.34315 1 5V22C1 22.5523 1.44772 23 2 23H4C4.55228 23 5 22.5523 5 22V21H13V22C13 22.5523 13.4477 23 14 23H16C16.5523 23 17 22.5523 17 22V16.4418C16.672 16.4802 16.3383 16.5 16 16.5C15.6617 16.5 15.328 16.4802 15 16.4418V18C15 18.5523 14.5523 19 14 19H4C3.44772 19 3 18.5523 3 18V14H9.9792C9.39315 13.4119 8.8927 12.7385 8.4981 12H3V10.6667L5 8H7.5C7.5 7.31112 7.58195 6.64138 7.73663 6H4.5C4.18524 6 3.88885 6.14819 3.7 6.4L3 7.33333V5C3 4.44772 3.44772 4 4 4H8.4981C8.8927 3.26149 9.39315 2.58807 9.9792 2Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M23 8C23 11.866 19.866 15 16 15C12.134 15 9 11.866 9 8C9 4.13401 12.134 1 16 1C19.866 1 23 4.13401 23 8ZM21 8C21 10.7614 18.7614 13 16 13C13.2386 13 11 10.7614 11 8C11 5.23858 13.2386 3 16 3C18.7614 3 21 5.23858 21 8ZM16.4945 4.00492L14.9945 4.00488L14.9944 9.0098L18.6191 11.1462L19.3808 9.85399L16.4944 8.15275L16.4945 4.00492Z" fill="currentColor" />
  </svg>
);

HourlyWork.propTypes = propTypes;

export default HourlyWork;
